import { Events } from '@/utils/events'
import { Network } from '../../../utils/network'

import urls from './urls.json'

async function customizeAffiliationCode(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  let url = urls.customizeAffiliationCode
  const userReference = await self.servicesVars.getUserReference()
  const userData = await self.servicesVars.getUserData()
  const countryCode = await self.servicesVars.getUserCountryCode()

  const body = {
    type: 'kingrecharge-affiliation-code-request',
    metadata: {
      userName: `${userData.firstName} ${userData.lastName}`,
      userPublicId: userData.metaData?.publicId,
      country: countryCode,
      userId: userReference,
      code: data.code,
    },
  }
  const response = await Network.sendPostRequest(url, body)
  return response
}

function parseResponse(response) {
  if (response && response.status.code === 200) {
    const data = {
      success: true,
    }
    return data
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: "Nous n'arrivons pas à contacter internet, veuillez réessayer",
      networkError: true,
    }
  }
  return {
    success: false,
    message:
      response?.response?.message ||
      "Désolé, une erreur s'est produite, veuilez réessayer",
  }
}

export { customizeAffiliationCode }
